import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcRequirementSmartComplianceById,
    setCcRequirementSmartComplianceEdit,
    setCcRequirementSmartComplianceReloadEdit,
    initCcRequirementSmartCompliance,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface SmartComplianceEditProps {
    complianceId: number
    editAccess: boolean
}

const Edit = ({
    complianceId,
    editAccess,
}: SmartComplianceEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const compliance = useSelector((state: StoreType) => state.ccRequirementSmartCompliance.complianceEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccRequirementSmartCompliance.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcRequirementSmartComplianceReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcRequirementSmartComplianceReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (complianceId === 0) {
            dispatch(setCcRequirementSmartComplianceEdit(initCcRequirementSmartCompliance))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcRequirementSmartComplianceById(complianceId, userData.accountId, project.id).then((res) => {
                dispatch(setCcRequirementSmartComplianceEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!compliance) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {
                        compliance.id
                            ? (
                                editAccess
                                    ? `${lang.editSmartCompliance} #${compliance.id}`
                                    : `${lang.viewSmartCompliance} #${compliance.id}`
                            )
                            : lang.addSmartCompliance
                    }
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form compliance={compliance} editAccess={editAccess} />
                }
                {
                    reloadEdit
                    && <Form compliance={compliance} editAccess={editAccess} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
